import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import { GroupDto } from '../Types/GroupDto'
import Group from '../Classes/Group'

export class GroupApiAdapter implements ApiDataAdapter<Group> {
    public createClass(apiData: GroupDto): Group {
        return new Group({
            id: get(apiData, 'id'),
            text: get(apiData, 'text'),
        })
    }
}
